import { omitBy } from 'lodash-es';

export const cleanQueryParams = (params: any) => {
  return omitBy(params, (value) => value === '' || value === undefined);
};
